import React from 'react'
import { Calendar } from '~/components/coach_services/OutplacementBenefits/Calendar'
import ColorKeyDialog from '../CoachDashboard/LiveEvents/ColorKeyDialog'
import { Button } from '~/lib/ui/button'
import CoachDashboardProvider, {
  useCoachDashboard,
} from '../CoachDashboard/CoachDashboardProvider'
import { TranslationProvider } from '../shared/TranslationProvider'
import translations from './locales.json'

const InnerLiveEventsSection = ({ eventsUrl }) => {
  const { setShowColorKeyDialog } = useCoachDashboard()

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-end">
        <ColorKeyDialog />
        <Button
          variant="link"
          size="sm"
          className="!rounded-full !px-4 !py-2"
          onClick={() => setShowColorKeyDialog(true)}
        >
          Color Code Key
        </Button>
      </div>

      <Calendar
        eventsUrl={eventsUrl}
        homePageDisplay={false}
        opRedesign={true}
        csmDashboardDisplay={true}
        disableDialog={true}
      />
    </div>
  )
}

const LiveEventsSection = ({ eventsUrl }) => (
  <TranslationProvider
    locale="en"
    translations={translations}
    scope="javascript.components.Dashboard.LiveEvents"
  >
    <CoachDashboardProvider>
      <InnerLiveEventsSection eventsUrl={eventsUrl} />
    </CoachDashboardProvider>
  </TranslationProvider>
)

export default LiveEventsSection
